"use client";

import { useState } from "react";
import { CommonConfigEditModal } from "./Modal";

export function AdminCommonConfigEdit() {
  const [isOpen, setIsOpen] = useState(false);
  const onShow = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <>
      <button
        className="btn btn-xs btn-icon btn-circle btn-secondary mx-1"
        onClick={onShow}
      >
        <i className="fa fa-cog"></i>
      </button>
      <CommonConfigEditModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
